export const clothesDummy = [
  {
    min: -100,
    max: 4,
    clothes: [
      '패딩',
      '두꺼운 코트',
      '목도리',
      '장갑',
      '내복',
      '바지 안에 레깅스',
    ],
  },
  {
    min: 5,
    max: 8,
    clothes: ['코트', '플리스', '니트', '가디건', '기모 티셔츠', '기모 바지'],
  },
  {
    min: 9,
    max: 11,
    clothes: [
      '트렌치코트',
      '야상',
      '자켓',
      '경량 패딩',
      '가디건',
      '니트',
      '긴 바지',
    ],
  },
  {
    min: 12,
    max: 16,
    clothes: ['기모 후드티', '가디건', '니트', '맨투맨', '자켓', '긴 바지'],
  },
  {
    min: 17,
    max: 19,
    clothes: [
      '바람막이',
      '얇은 가디건',
      '얇은 니트',
      '후드티',
      '맨투맨',
      '슬랙스',
      '긴 바지',
    ],
  },
  {
    min: 20,
    max: 23,
    clothes: ['긴팔 (티)셔츠', '얇은 가디건', '면바지', '청바지', '7부 바지'],
  },
  {
    min: 24,
    max: 27,
    clothes: ['반팔 (티)셔츠', '리넨 셔츠', '반바지', '면 바지'],
  },
  {
    min: 28,
    max: 100,
    clothes: ['반팔 티셔츠', '민소매', '반바지', '짧은 바지', '얇은 원피스'],
  },
];
